<template>
  <div id="production" :style="{ width: width, height: height }"></div>
</template>
<script>
import * as echarts from 'echarts';
export default {
  data() {
    return {
      years: [],
      charts: '',
      // 指定图表的配置项和数据
      option: {
        title: {
          show: false,
          text: 'Stacked Area Chart',
        },
        // tooltip: {
        //   color: ["#32C8E1"],
        //   show: true,
        //   trigger: 'axis',
        //   // backgroundColor: 'blue',
        //   // 让toolltip紧跟鼠标
        //   // 打开tooltip有可能鼠标移入的时候会出现屏幕抖动情况
        //   // 设置transitionDuration为0可以解决此问题
        //   transitionDuration: 0, // 让toolltip紧跟鼠标
        //   axisPointer: {
        //     type: 'cross', // 'line' 直线指示器 'shadow' 阴影指示器 'none' 无指示器 'cross' 十字准星指示器。其实是种简写，表示启用两个正交的轴的 axisPointer。
        //     label: {
        //       backgroundColor: '#32C8E2',
        //     },
        //   },
        // },
        // legend: {
        //   show: false,
        //   textStyle: {
        //     color: '#fff',
        //     fontSize: 13,
        //   },
        // },
        grid: {
          top: '5%',
          left: '0%',
          right: '2%',
          bottom: '0%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            // name:'(时间)',
            // nameTextStyle: {
            //   color:'#fff',
            //   fontSize:12,
            //   verticalAlign:'top'
            // },
            // boundaryGap: false,
            //
            data: [],
            axisTick: {
              show: false,
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: {
                color: '#0f5681',
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#32C8E2',
                type: 'dotted',
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff', //更改坐标轴文字颜色
                fontSize: 12, //更改坐标轴文字大小
              },
            },
          },
        ],
        yAxis: {
          type: 'value',
          name: this.yUnit,
          nameTextStyle: {
            color: '#fff',
            fontSize: 12,
            align: 'right',
          },
          axisLine: {
            lineStyle: {
              color: '#0f5681',
            },
          },
          axisTick: {
            show: false,
            // alignWithLabel: true,
          },
          splitLine: {
            lineStyle: {
              color: '#0F2275',
              type: 'solid', // solid dashed dotted
            },
          },
          axisLabel: {
            show: true,
            align: 'right',
            textStyle: {
              color: '#fff', //更改坐标轴文字颜色
              fontSize: 12, //更改坐标轴文字大小
            },
          },
        },
        series: [
          {
            name: '',
            type: 'bar',
            data: [],
            // data: [],
            lineStyle: {
              color: '#32C8E2',
            },
            barMaxWidth: 50,
            itemStyle: {
              // 线和拐点的颜色
              borderColor: '#32C8E1',
              color: '#32C8E1', //图例的颜色
            },
            label: {
              show: true,
            },
          },
        ],
      },
    };
  },
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '13vw',
    },
    data: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: '',
    },
    xValue: {
      type: Array,
      default: () => [],
    },
    yUnit: {
      type: String,
      default: '',
    },
    yValue: {
      type: Array,
      default: () => [],
    },
  },
  // watch: {
  //   yValue(newValue) {
  //     this.drawLine();
  //   },
  // },
  destroyed() {
    window.removeEventListener('resize', this.selfAdaption);
  },
  methods: {
    drawLine(arr) {
      // const date = new Date();
      // const now = date.getFullYear();
      // let list = [];
      // list.push(now);
      // for (let i = 1; i < 5; i++) {
      //   list.push(now - i - 1);
      // }
      this.option.xAxis[0].data = arr.map(x => { return x.Name });
      this.option.series[0].data = arr.map(x => { return x.Value });
      // console.log('now',list);
      // 基于准备好的dom，初始化echarts实例
      this.charts = echarts.init(document.getElementById('production'));

      // 使用刚指定的配置项和数据显示图表。
      this.charts.setOption(this.option);
      window.addEventListener('resize', this.selfAdaption);
    },

    // 自适应
    selfAdaption() {
      if (!this.charts) return;
      this.charts.resize();
      // this.drawLine();
    },
  },
};
</script>
